const PLACEHOLDER = '--'

export function fmtPrice(val, sqm = false) {
  if (val === 0 || val == null) return PLACEHOLDER
  return sqm ? '$' + val.toFixed(1) : '$' + Math.round(val)
}

export function fmtPct(val) {
  if (val === 0 || val == null || Number.isNaN(val)) return PLACEHOLDER
  return (val > 0 ? '+' : '') + val.toFixed(1) + '%'
}

export function fmtOcc(val) {
  if (val == null || Number.isNaN(val)) return PLACEHOLDER
  return val.toFixed(1) + '%'
}

export function fmtCurrency(val, decimals = 0) {
  if (val == null || Number.isNaN(val)) return PLACEHOLDER
  return '$' + (decimals > 0 ? Number(val).toFixed(decimals) : Math.round(val))
}

export function fmtInt(val) {
  if (val == null || Number.isNaN(val)) return PLACEHOLDER
  return Math.round(val).toLocaleString('en-AU')
}

export function fmtDays(val) {
  if (val == null || Number.isNaN(val)) return PLACEHOLDER
  return Math.round(val) + 'd'
}

export function pctChange(from, to) {
  const diff = to / from
  if (Number.isNaN(diff)) return 0
  if (!Number.isFinite(diff)) return 100
  return (diff - 1) * 100
}

export function formatLargeNumber(n, decimals = 1) {
  if (n == null || isNaN(n)) return '—'
  const abs = Math.abs(n)
  const sign = n < 0 ? '-' : ''
  if (abs >= 1e9) return `${sign}${(abs / 1e9).toFixed(decimals)}B`
  if (abs >= 1e6) return `${sign}${(abs / 1e6).toFixed(decimals)}M`
  if (abs >= 1e3) return `${sign}${(abs / 1e3).toFixed(decimals)}K`
  if (Number.isInteger(abs) || abs < 10) return `${sign}${Math.round(abs)}`
  return `${sign}${abs.toFixed(decimals)}`
}

export function fmtAxisTick(val, unit) {
  if (unit === 'currency') return `$${Math.round(val)}`
  if (unit === 'percent') return `${Number(val).toFixed(0)}%`
  if (unit === 'days') return `${Math.round(val)}d`
  return formatLargeNumber(val, 0)
}
